import {
  MaintenanceItem, MaintenanceItemActive, MaintenanceItemApi, MaintenanceItemMutation // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { AxiosPromise, AxiosResponse } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/my-trips'

export default class ExtendedMaintenanceItemApi extends MaintenanceItemApi {
  public createMaintenanceItems (vehicleId: number, request: MaintenanceItemMutation, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createMaintenanceItems(vehicleId, request, undefined, optionsParam)
  }

  public deleteMaintenanceItem (vehicleId: number, id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deleteMaintenanceItem(vehicleId, id, undefined, optionsParam)
  }

  public getMaintenanceItems (options?: any): AxiosPromise<Array<MaintenanceItem>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getMaintenanceItems(undefined, optionsParam)
  }

  public updateMaintenanceItemActive (vehicleId: number, id: number, request: MaintenanceItemActive, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateMaintenanceItemActive(vehicleId, id, request, undefined, optionsParam)
  }

  public updateMaintenanceItems (vehicleId: number, id: number, request: MaintenanceItemMutation, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateMaintenanceItems(vehicleId, id, request, undefined, optionsParam)
  }
}
